module.exports = __webpack_public_path__ + "img/c_v2.3edcd55.png";